import React from 'react';
import InfoField from './InfoField';

const EmploymentUANCheckSection = ({ uanChecks }) => {
  if (!uanChecks || uanChecks.length === 0) {
    return (
      <div className="report-section">
        <h2 className="section-title">Employment UAN Check Details</h2>
        <p>No UAN check details available.</p>
      </div>
    );
  }

  return (
    <div className="admin-report-section">
      <h2 className="admin-section-title">Employment UAN Check Details</h2>
      {uanChecks.map((check, index) => (
        <div key={index} className="uan-check-entry-card">
          <h3>UAN Check Entry {index + 1}</h3>
          <div className="grid-container">
            <InfoField label="UAN" value={check.uan || 'N/A'} />
            <InfoField label="Name" value={check.name || 'N/A'} />
            <InfoField label="Member ID" value={check.memberId || 'N/A'} />
            <InfoField label="Date of Joining (EPF)" value={check.dojEpf || 'N/A'} />
            <InfoField label="Date of Exit (EPF)" value={check.doeEpf || 'N/A'} />
            <InfoField label="Month History" value={check.monthHistory || 'N/A'} />
            <InfoField label="Company Name" value={check.companyName || 'N/A'} />
            <InfoField label="Company Address" value={check.companyAddress || 'N/A'} />
            <InfoField label="Leave Reason" value={check.leaveReason || 'N/A'} />
            <InfoField label="Verified" value={check.verified ? 'Yes' : 'No'} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default EmploymentUANCheckSection;